import { createContext, useContext, useMemo } from "react";
import { useFetchSubscription } from "services/mercadopago";
import { useUser } from "contexts";

const Credits = createContext();

export const CreditsProvider = ({ children, plans }) => {
  const { planId, ...fs } = useFetchSubscription();
  const { profile } = useUser();

  const hasCredits = fs.availableCredits >= 10;
  const isNewUser = profile?.storyIds?.length === 0;
  const authorized = hasCredits && (fs.isPremium || isNewUser);

  const plan = useMemo(() => {
    if (!plans || !planId) return null;
    return plans.find((plan) => plan._id === planId);
  }, [plans, planId]);

  return (
    <Credits.Provider
      value={{
        ...fs,
        authorized,
        planId,
        plan,
      }}
    >
      {children}
    </Credits.Provider>
  );
};

export const usePremium = () => useContext(Credits);
